import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Report from "../Report";
import { TextField } from "@material-ui/core";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function PlayerCountByAgent() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Player Count By Agent"
        getUrl={() => "/Reports/Report_PlayerCountByAgent_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Distributor: distributor,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const total =
              item.phoneAccess + item.onlineAccess + item.bothAccess;

            return { ...item, total };
          })
        }
        getTotals={(data) => ({
          agent: "Total",
          phoneAccess: data.reduce((acc, item) => acc + item.phoneAccess, 0),
          onlineAccess: data.reduce((acc, item) => acc + item.onlineAccess, 0),
          bothAccess: data.reduce((acc, item) => acc + item.bothAccess, 0),
          total: data.reduce((acc, item) => acc + item.total, 0),
        })}
      >
        {/* REAL COLUMNS */}
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneAccess">
          Phone Access
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="onlineAccess">
          Online Access
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="bothAccess">
          Both Access
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="total">
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default PlayerCountByAgent;
